import { useEffect } from 'react'
import { ParticleBackground } from '../components/ParticleBackground'
import { HeroBanner } from '../components/HeroBanner'
import { useUserProfile } from '../hooks/useUserProfile'
import { useAuth } from '../hooks/useAuth'
import '../styles/Home.css'

export function Home() {
  const { isAuthenticated } = useAuth();
  const { fetchUserProfile } = useUserProfile();

  useEffect(() => {
    // Fetch user profile when authenticated
    if (isAuthenticated) {
      fetchUserProfile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  return (
    <div className="home-page">
      <div className="position-relative bg-white home-page-content">
        <ParticleBackground />
        <HeroBanner />
      </div>
    </div>
  )
}
